import { combineReducers } from 'redux';

import image from './image';
import user from './user';

export default combineReducers({ image, user });